import Page from './page'
import Blurb from './blurb/blurb'
import Product from './product/product'

export default {
  page: Page,
  blurb: Blurb,
  product: Product
}